import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ENV_CONFIG } from '@ps/core-config';
import {
  CompanySupplierSettingsResponseDto,
  SupplierSettingsApiStatusResponseDto,
} from './dtos/company-supplier-settings.dto';
import { CompanySupplierSettingsMapper } from './mappers/company-supplier-settings.mapper';
import { CompanySupplierSettingsPayloadMapper } from './mappers/company-supplier-settings-payload.mapper';
import { SupplierSettingsForm } from '../models/company-form.model';

@Injectable({ providedIn: 'root' })
export class CompanySupplierSettingsApi {
  private readonly _httpClient = inject(HttpClient);
  private readonly _environmentConfig = inject(ENV_CONFIG);
  private readonly _baseUrl = this._environmentConfig.pureSpectrum.url;
  private readonly _mapper = new CompanySupplierSettingsMapper();
  private readonly _payloadMapper = new CompanySupplierSettingsPayloadMapper();

  public supplierSettings(companyId: number): Observable<SupplierSettingsForm> {
    return this._httpClient
      .get<CompanySupplierSettingsResponseDto>(
        `${this._baseUrl}/supplierSettings/${companyId}`,
      )
      .pipe(map((response) => this._mapper.fromDto(response.supplier[0])));
  }

  public updateSupplierSettings(
    companyId: number,
    form: SupplierSettingsForm,
  ): Observable<SupplierSettingsApiStatusResponseDto> {
    const payload = {
      cmp: companyId,
      ...this._payloadMapper.toPayload(form),
    };

    return this._httpClient.put<SupplierSettingsApiStatusResponseDto>(
      `${this._baseUrl}/supplierSettings/${companyId}`,
      payload,
    );
  }

  public setSegmentation(
    companyId: number,
    isSegmentationEnabled: boolean,
  ): Observable<SupplierSettingsApiStatusResponseDto> {
    return this._httpClient.put<SupplierSettingsApiStatusResponseDto>(
      `${this._baseUrl}/supplierSettings/${companyId}`,
      { cmp: companyId, isSegmentationEnabled },
    );
  }
}
